import { render, staticRenderFns } from "./enterpriseNews.vue?vue&type=template&id=3dc80b0e&scoped=true"
import script from "./enterpriseNews.vue?vue&type=script&lang=js"
export * from "./enterpriseNews.vue?vue&type=script&lang=js"
import style0 from "./enterpriseNews.vue?vue&type=style&index=0&id=3dc80b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc80b0e",
  null
  
)

export default component.exports